import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import { Divider, Radio, Row, Space } from "antd";

import * as Common from "../commons/common";
import * as Request from "../commons/request";
import * as Types from "../commons/typeDTO";
import * as Utils from "../utils/utils";
import * as Strings from "../commons/string";

import PageContainer from "../layout/PageContainer";
import styles from "./ReturnResultPayments.module.css";

function ReturnResultPayments() {
    const params = useParams();
    const navigate = useNavigate();

    const [currentRentId, setCurrentRentId] = useState<number>();
    const [rent, setRent] = useState<Types.RentDto>();

    const [paymentCategories, setPaymentCategories] = useState<Array<Types.RentPaymentCategoryDto>>();
    const [penaltyTotalAmount, setPenaltyTotalAmount] = useState<number>(0);

    const [penaltyPayment, setPenaltyPayment] = useState<Array<Types.RentPaymentDto>>([]);
    const [paymentMethodType, setPaymentMethodType] = useState("OFFLINE_CARD");

    useEffect(() => {
        if (params.rentId) setCurrentRentId(Number(params.rentId));
    }, [params.rentId]);

    useEffect(() => {
        Utils.onEvent(Common.EVENT_NEXT_PROCESS, goToNextProcess);

        Utils.triggerEvent(Common.EVENT_ENABLE_PROCESS_BUTTON, true);

        console.log("currentRentId", currentRentId);

        if (currentRentId) {
            requestGetPaymentCategories();
            requestGetRent();
        }

        return () => {
            Utils.offEvent(Common.EVENT_NEXT_PROCESS, goToNextProcess);
        };
    }, [currentRentId]);

    const goToNextProcess = () => {
        changePaymentMethod();
    };

    const requestAxiosGetRent = async () => {
        const response = await utilAxiosWithAuth().get(Request.RENT_URL + currentRentId);
        return response.data;
    };

    const { loading: loadingGetRent, error: errorGetRent, data: resultGetRent, execute: requestGetRent } = useAsyncAxios(requestAxiosGetRent);

    useEffect(() => {
        if (resultGetRent === null) return;
        console.log("resultGetRent", resultGetRent);
        setRent(resultGetRent.rent);
    }, [resultGetRent]);

    useEffect(() => {
        if (errorGetRent === null) return;
        console.log("errorGetRent", errorGetRent);
    }, [errorGetRent]);

    useEffect(() => {
        if (rent === undefined) return;

        setPenaltyPayment(
            rent.rentPayments.filter(
                (payment) =>
                    (payment.rentPaymentType === "PENALTY" || payment.rentPaymentType === "INSURANCE") &&
                    (payment.paidDate === null || payment.paidDate === undefined)
            )
        );
    }, [rent]);

    useEffect(() => {
        console.log("penaltyPayment", penaltyPayment);
        if (penaltyPayment.length > 0) {
            let totalAmount = 0;
            penaltyPayment.forEach((payment) => (totalAmount += payment.amount));
            setPenaltyTotalAmount(totalAmount);
        }
    }, [penaltyPayment]);

    const changePaymentMethod = () => {
        if (paymentMethodType === "OFFLINE_CARD") {
            onReturnRent();
        } else {
            const tempUpdateItems = [...penaltyPayment];
            const updateItem = tempUpdateItems.shift();

            setPenaltyPayment(tempUpdateItems);

            if (updateItem) {
                requestUpdatePayment(updateItem);
            } else {
                onReturnRent();
            }
        }
    };

    const requestAxiosGetPaymentCategories = async () => {
        console.log("requestAxiosGetPaymentCategories");
        const response = await utilAxiosWithAuth().get(Request.RENT_PAYMENT_CATEGORIES_URL);
        return response.data;
    };

    const {
        loading: loadingGetPaymentCategories,
        error: errorGetPaymentCategories,
        data: resultGetPaymentCategories,
        execute: requestGetPaymentCategories,
    } = useAsyncAxios(requestAxiosGetPaymentCategories);

    useEffect(() => {
        if (resultGetPaymentCategories === null) return;
        console.log("resultGetPaymentCategories", resultGetPaymentCategories);
        setPaymentCategories(resultGetPaymentCategories.rentPaymentCategories);
    }, [resultGetPaymentCategories]);

    useEffect(() => {
        if (errorGetPaymentCategories === null) return;
        console.log("errorGetPaymentCategories", errorGetPaymentCategories);
    }, [errorGetPaymentCategories]);

    const requestAxiosUpdatePayment = async (updateItem: Types.RentPaymentDto) => {
        const payment = {
            paymentMethod: paymentMethodType,
        };
        const response = await utilAxiosWithAuth().put(Request.RENT_PAYMENT_URL + updateItem.rentPaymentId, payment);
        return response.data;
    };

    const {
        loading: loadingUpdatePayment,
        error: errorUpdatePayment,
        data: resultUpdatePayment,
        execute: requestUpdatePayment,
    } = useAsyncAxios(requestAxiosUpdatePayment);

    useEffect(() => {
        if (resultUpdatePayment === null) return;
        console.log("resultUpdatePayment", resultUpdatePayment);
        changePaymentMethod();
    }, [resultUpdatePayment]);

    useEffect(() => {
        if (errorUpdatePayment === null) return;
        console.log("errorUpdatePayment", errorUpdatePayment);
    }, [errorUpdatePayment]);

    const onReturnRent = () => {
        requestReturnRent();
    };

    const requestAxiosReturnRent = async () => {
        const response = await utilAxiosWithAuth().put(Request.RENT_URL + currentRentId + Request.RENT_RETURN_URL);
        return response.data;
    };

    const {
        loading: loadingReturnRent,
        error: errorReturnRent,
        data: resultReturnRent,
        execute: requestReturnRent,
    } = useAsyncAxios(requestAxiosReturnRent);

    useEffect(() => {
        if (resultReturnRent === null) return;
        console.log("resultReturnRent", resultReturnRent);
        navigate(Common.PAGE_RENT_DETAIL + "/" + currentRentId);
    }, [resultReturnRent]);

    useEffect(() => {
        if (errorReturnRent === null) return;
        console.log("errorReturnRent", errorReturnRent);
    }, [errorReturnRent]);

    const displayPaymentCategories = () => {
        if (paymentCategories === undefined) return null;

        return paymentCategories.length > 0
            ? paymentCategories.map((category) => {
                  let paymentList: Types.RentPaymentDto[] = [];
                  if (rent !== undefined && rent.rentPayments !== undefined) {
                      paymentList = rent.rentPayments.filter(
                          (payment) =>
                              (payment.rentPaymentType === "PENALTY" || payment.rentPaymentType === "INSURANCE") &&
                              payment.rentPaymentItem.rentPaymentCategory.rentPaymentCategoryId === category.rentPaymentCategoryId
                      );
                  }
                  if (paymentList.length === 0) return null;

                  return (
                      <div key={category.rentPaymentCategoryId}>
                          <Row>
                              <h4 className={styles.subTitle}>{category.rentPaymentCategoryName}</h4>
                          </Row>
                          {paymentList.length > 0 &&
                              paymentList.map((payment) => {
                                  return (
                                      <Row key={payment.rentPaymentId} align="middle" justify="space-between">
                                          <p>{payment.rentPaymentItem.rentPaymentItemName}</p>
                                          <p>{Utils.convertCurrencyKorean(payment.amount)}</p>
                                      </Row>
                                  );
                              })}
                          <Divider className={styles.divider} />
                      </div>
                  );
              })
            : null;
    };

    return (
        <PageContainer>
            <Row>
                <h3 className={styles.subTitle} style={{ marginBottom: "10px" }}>
                    세부항목
                </h3>
            </Row>
            {displayPaymentCategories()}
            <Row align="middle" justify="space-between">
                <h3 className={styles.subTitle}>총 결제 금액</h3>
                <h3 className={styles.subTitle} style={{ color: "#006AF5" }}>
                    {Utils.convertCurrencyKorean(penaltyTotalAmount)}
                </h3>
            </Row>
            <>
                <Divider className={styles.bigDivider} />
                <Space direction="vertical">
                    <h4 className={styles.subTitle}>결제 방법</h4>
                    <Radio.Group value={paymentMethodType} onChange={(e) => setPaymentMethodType(e.target.value)}>
                        <Space direction="vertical">
                            <Radio value="OFFLINE_CARD">{Strings.offline_card}</Radio>
                            <Radio value="OFFLINE_BANK">{Strings.offline_bank}</Radio>
                            <Radio value="OFFLINE_CASH">{Strings.offline_cash}</Radio>
                        </Space>
                    </Radio.Group>
                </Space>
            </>
        </PageContainer>
    );
}

export default ReturnResultPayments;
